export enum ResourceAction {
    SAVE          = 'Save',
    PROPERTIES    = 'Properties',
    MEMBERS       = 'Members',
    CLOSE         = 'Close',

    UNKNOWN       = 'unknown',
}